"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UILoadingDots = _interopRequireDefault(require("./UILoadingDots"));

var _UILoadingSpinner = _interopRequireDefault(require("./UILoadingSpinner"));

var _UIOverlay = _interopRequireDefault(require("../overlay/UIOverlay"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _Styles = require("../utils/Styles");

var _decorators = require("../utils/propTypes/decorators");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var OverlayInnerWrapper = (0, _styledComponents.default)(_UIOverlay.default.defaultProps.Inner).withConfig({
  displayName: "UILoadingOverlay__OverlayInnerWrapper",
  componentId: "sc-1jt1k53-0"
})(_templateObject());
var DEFAULT_USE = 'spinner';
var USE_VARIANTS = {
  dots: {
    Component: function Component(_ref) {
      var label = _ref.label,
          rest = (0, _objectWithoutProperties2.default)(_ref, ["label"]);
      return _react.default.createElement(_UILoadingDots.default, (0, _extends2.default)({}, rest, {
        title: label
      }));
    }
  },
  spinner: {
    Component: function Component(_ref2) {
      var label = _ref2.label,
          rest = (0, _objectWithoutProperties2.default)(_ref2, ["label"]);
      return _react.default.createElement(_UILoadingSpinner.default, (0, _extends2.default)({}, rest, {
        label: label
      }));
    }
  }
};

function getOverlayStyles(minHeight) {
  if (minHeight == null) return undefined;
  return {
    minHeight: (0, _Styles.toPx)(minHeight)
  };
}

var UILoadingOverlay = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UILoadingOverlay, _Component);

  function UILoadingOverlay(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UILoadingOverlay);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILoadingOverlay).call(this, props));
    _this._getOverlayStyles = (0, _memoizeOne.default)(getOverlayStyles);
    return _this;
  }

  (0, _createClass2.default)(UILoadingOverlay, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contextual = _this$props.contextual,
          use = _this$props.use,
          minHeight = _this$props.minHeight,
          label = _this$props.label,
          title = _this$props.title,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["contextual", "use", "minHeight", "label", "title"]);
      var Loader = (USE_VARIANTS[use] || USE_VARIANTS[DEFAULT_USE]).Component;
      return _react.default.createElement(_UIOverlay.default, {
        centerContent: false,
        contextual: contextual,
        Inner: OverlayInnerWrapper,
        use: "light",
        width: 100,
        style: this._getOverlayStyles(minHeight)
      }, _react.default.createElement(Loader, (0, _extends2.default)({}, rest, {
        label: label || title
      })));
    }
  }]);
  return UILoadingOverlay;
}(_react.Component);

exports.default = UILoadingOverlay;
UILoadingOverlay.displayName = 'UILoadingOverlay';
UILoadingOverlay.propTypes = {
  minHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  title: (0, _decorators.hidden)((0, _decorators.notRequired)(_UILoadingDots.default.propTypes.title)),
  label: (0, _decorators.notRequired)(_UILoadingSpinner.default.propTypes.label),
  contextual: _UIOverlay.default.propTypes.contextual,
  use: _propTypes.default.oneOf(Object.keys(USE_VARIANTS))
};
UILoadingOverlay.defaultProps = {
  use: DEFAULT_USE,
  contextual: false,
  showLabel: false
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/loading/UILoadingOverlay.js
// module id = 848
// module chunks = 209 210 211 212